import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import authReducer from './slices/authSlice';
import { apiClient } from './api/apiClient';
import supportReducer from './slices/supportSlice';
import documentsReducer from './slices/documentsSlice';
import organizationReducer from './slices/organizationSlice';
import portfolioReducer from './slices/portfolioSlice';
import siteReducer from './slices/siteSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    support: supportReducer,
    documents: documentsReducer,
    organization: organizationReducer,
    portfolio: portfolioReducer,
    site: siteReducer,
    [apiClient.reducerPath]: apiClient.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiClient.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


